import { getRoles, clearLocalStorage } from "@/services/config";
import KeycloakService from "@/services/keycloak/keycloakService";

export function guardAdmin(to: any, from: any, next: any) {
    if(getRoles() == "ADMIN_IOSI" || getRoles() == "ADMIN"){ 
        next()
    } else {
        KeycloakService.CallLogout();
        clearLocalStorage();
    }
    
}